<div class="row">
  <div class="col">
    <div class="form-group">Name: {{ user.name }}</div>
    <div class="form-group">Username: {{ user.userName }}</div>
    <div class="form-group">Email: {{ user.emailAddress }}</div>
  </div>
</div>
